import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=8e953f68&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports